<template></template>

<script>
import api from "@/api";
import config from "@/config";
import { mapActions } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Public",
  access_code: "PUBLIC",
  excludeSideBar: true,
  hidden: true,
  created() {
    if(this.$route.query.ACCESS_CODE=="PUBLIC"){
      console.log(this.$route.query.ACCESS_CODE);
      this.logout();
    }
    
    if (!helper.getUser()) {
      api.request(
        this,
        "post",
        "/system/authenticate",
        {
          SessionID: null,
          LocaleCode: config.defaultLocale,
          Parameters: {
            method: "PUBLIC",
            username: null,
            password: null
          }
        },
        function(r) {
          this.loginSuccess(r);
          this.directTo();
        },
        function(r) {
          // this.loginFail(r);
        }
      );
    }else{
      this.directTo();
    }
    // this.$router.push("/Builder/FormBuilder/RequestForm").catch(err => {});
  },
  methods: {
    ...mapActions([
      "actionSetToken",
      "actionSetMessage",
      "actionSetUser",
      "actionSetSidLogin"
    ]),
    loginSuccess(r) {
      if (r.code === 200) {
        console.log(r.data.user_profile);
        this.actionSetUser(r.data.user_profile);
        this.actionSetToken(r.data.session_id);
        this.actionSetSidLogin(this.sidLogin);
        // Support refresh

        // this.$router.go(0);
      }
    },
    directTo() {
      let isworkid = this.$route.query.ISWORK_ID;
      let sub_id = this.$route.query.SUBSCRIPTION_ID;
      this.$router.push({
        path: "/Mobile/Forms/Form/request/",
        query: { ISWORK_ID: isworkid, SUBSCRIPTION_ID: sub_id }
      });
    },

    logout() {
      this.actionSetUser("actionSetUser", {});
      this.actionSetToken("actionSetToken", null);
      if (this.$msal&&this.$msal.isAuthenticated()) {
        this.$msal.signOut();
      }

      if (window.localStorage) {
        // window.localStorage.setItem("ccrs_user", "null");
        // window.localStorage.setItem("ccrs_token", "null");
        // window.localStorage.clear();
        this.$helper.removeStorageItem("ccrs_user");
        this.$helper.removeStorageItem("ccrs_token");
      }

      // Clear all cookies
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name +
          "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" +
          location.host;
      }
    }
  }
};
</script>

<style>
</style>